/**
 * Parses the application version string into a UI-friendly format.
 */
export const parseAppVersion = (versionStr: string): string => {
  // Check for specific local dev patterns
  if (versionStr.includes('dev') || versionStr === '0.0.0-dev') {
    return 'dev'
  }

  // Check for CI/CD Date format (YYYYMMDD at the start)
  const dateMatch = versionStr.match(/^(\d{4})(\d{2})(\d{2})-(\w{2,10})$/)

  if (dateMatch) {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    const [_, year, month, day, hash] = dateMatch
    return `${year}.${month}.${day}-${hash}`
  }

  // Fallback: return as-is (Handles "1.1.0", "1.2", "V2", etc.)
  return versionStr
}
